import { render, staticRenderFns } from "./describe.vue?vue&type=template&id=c4fd68b4&"
import script from "./describe.ts?vue&type=script&lang=ts&"
export * from "./describe.ts?vue&type=script&lang=ts&"
import style0 from "./describe.vue?vue&type=style&index=0&id=c4fd68b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports